<template>
  <div>
    <div class="md-layout md-gutter mt-2">
      <div class="md-layout-item md-size-80">
        <h1 class="md-title">
          {{ componente ? 'Editar' : 'Cadastrar' }} Componente
        </h1>
      </div>
      <div class="md-layout-item" style="text-align: right">
        <md-button
          class="md-icon-button md-list-action"
          @click="() => emitCloseEvent()"
        >
          <md-icon class="md-size-2x"> close </md-icon>
        </md-button>
      </div>
    </div>
    <md-field v-if="componente">
      <label for="ordem">Ordem</label>
      <md-input id="ordem" v-model.number="componente.z" type="number" />
    </md-field>
    <ViewTimeSeriesForm
      v-if="showTimeSeries"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />
    <ViewGraphicalForm
      v-if="showGraphical"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />
    <ViewTextForm
      v-if="showText"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />
    <ViewDialForm
      v-if="showDial"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />
    <ViewActionForm
      v-if="showAction"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />
    <ViewImageForm
      v-if="showImage"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />

    <ViewTabelaSensorVirtualMensalForm
      v-if="showTabela"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />

    <ViewPipeForm
      v-if="showPipe"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />

    <ViewNavigationForm
      v-if="showNavigation"
      :local-id="localId"
      :view-id="viewId"
      :componente="componente"
      @close="emitCloseEvent"
      @updated="updateView"
    />
  </div>
</template>

<script>
import ViewTabelaSensorVirtualMensalForm from '@/components/view/forms/ViewTabelaSensorVirtualMensalForm.vue'
import { ComponenteTipo } from '@/utils/componente'

import ViewActionForm from './forms/ViewActionForm.vue'
import ViewDialForm from './forms/ViewDialForm.vue'
import ViewGraphicalForm from './forms/ViewGraphicalForm.vue'
import ViewImageForm from './forms/ViewImageForm.vue'
import ViewNavigationForm from './forms/ViewNavigationForm.vue'
import ViewPipeForm from './forms/ViewPipeForm.vue'
import ViewTextForm from './forms/ViewTextForm.vue'
import ViewTimeSeriesForm from './forms/ViewTimeSeriesForm.vue'

export default {
  name: 'ViewComponenteForm',
  components: {
    ViewTabelaSensorVirtualMensalForm,
    ViewImageForm,
    ViewTimeSeriesForm,
    ViewGraphicalForm,
    ViewTextForm,
    ViewDialForm,
    ViewActionForm,
    ViewPipeForm,
    ViewNavigationForm,
  },
  props: {
    localId: {
      type: String,
      required: true,
    },
    viewId: {
      type: String,
      required: true,
    },
    componente: {
      type: Object,
      default: null,
    },
    componenteTipo: {
      type: Number,
      default: null,
    },
  },
  computed: {
    showText() {
      return this.componenteTipo === ComponenteTipo.TextView
    },
    showGraphical() {
      return this.componenteTipo === ComponenteTipo.GraphicalView
    },
    showImage() {
      return this.componenteTipo === ComponenteTipo.ImageView
    },
    showTabela() {
      return this.componenteTipo === ComponenteTipo.TabelaSensoresVirtuais
    },
    showTimeSeries() {
      return this.componenteTipo === ComponenteTipo.TimeSeriesView
    },
    showDial() {
      return this.componenteTipo === ComponenteTipo.DialView
    },
    showAction() {
      return this.componenteTipo === ComponenteTipo.ActionView
    },
    showPipe() {
      return this.componenteTipo === ComponenteTipo.PipeView
    },
    showNavigation() {
      return this.componenteTipo === ComponenteTipo.NavigationView
    },
  },
  methods: {
    emitCloseEvent() {
      this.$emit('close')
    },
    updateView() {
      this.$emit('updated')
    },
  },
}
</script>

<style scoped></style>
